import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainCalculatorsList from "../MainCalculators";
import SharedHelmet from "../../Helmet";
import RelatedLinks from "../../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../../Ads";
import imgUrl from "../../../../images/gold.webp";
const goldTypeTranslations = {
  "24k": "24 قيراط",
  "22k": "22 قيراط",
  "21k": "21 قيراط",
  "20k": "20 قيراط",
  "18k": "18 قيراط",
};
const countryTranslations = {
  global: "العالم",
  us: "أمريكا",
  uk: "بريطانيا",
  sa: "السعودية",
  ae: "الإمارات",
  eg: "مصر",
  kw: "الكويت",
  qa: "قطر",
  om: "عمان",
  bh: "البحرين",
  ye: "اليمن",
  ps: "فلسطين",
  jo: "الأردن",
  lb: "لبنان",
  sy: "سوريا",
  iq: "العراق",
  dz: "الجزائر",
  ly: "ليبيا",
  ma: "المغرب",
  tn: "تونس",
  sd: "السودان",
  tr: "تركيا",
  de: "ألمانيا",
  fr: "فرنسا",
  nl: "هولندا",
  se: "السويد",
  it: "إيطاليا",
  es: "أسبانيا",
  at: "النمسا",
  be: "بليجكا",
  ca: "كندا",
  au: "أستراليا",
};
const countryCurrencies = {
  global: "USD",
  us: "USD",
  uk: "GBP",
  sa: "SAR",
  ae: "AED",
  eg: "EGP",
  kw: "KWD",
  qa: "QAR",
  om: "OMR",
  bh: "BHD",
  ye: "YER",
  ps: "ILS",
  jo: "JOD",
  lb: "LBP",
  sy: "SYP",
  iq: "IQD",
  dz: "DZD",
  ly: "LYD",
  ma: "MAD",
  tn: "TND",
  sd: "SDG",
  tr: "TRY",
  de: "EUR",
  fr: "EUR",
  nl: "EUR",
  se: "SEK",
  it: "EUR",
  es: "EUR",
  at: "EUR",
  be: "EUR",
  ca: "CAD",
  au: "AUD",
};
const currencyNames = {
  global: "دولار امريكي",
  us: "دولار امريكي",
  uk: "جنيه استرليني",
  sa: "ريال سعودي",
  ae: "درهم اماراتي",
  eg: "جنيه مصري",
  kw: "دينار كويتي",
  qa: "ريال قطري",
  om: "ريال عماني",
  bh: "دينار بحريني",
  ye: "ريال يمني",
  ps: "شيكل اسرائيلي",
  jo: "دينار اردني",
  lb: "ليرة لبنانية",
  sy: "ليرة سورية",
  iq: "دينار عراقي",
  dz: "دينار جزائري",
  ly: "دينار ليبي",
  ma: "درهم مغربي",
  tn: "دينار تونسي",
  sd: "جنيه سوداني",
  tr: "ليرة تركية",
  de: "يورو",
  fr: "يورو",
  nl: "يورو",
  se: "كرونة سويدية",
  it: "يورو",
  es: "يورو",
  at: "يورو",
  be: "يورو",
  ca: "دولار كندي",
  au: "دولار أسترالي",
};
const goldPurityFactors = {
  "24k": 1.0,
  "22k": 0.9167,
  "21k": 0.875,
  "20k": 0.8333,
  "18k": 0.75,
};
function GoldPriceCalculator() {
  const { country } = useParams();
  const [goldType, setGoldType] = useState("24k");
  const [selectedGoldType, setSelectedGoldType] = useState("24k");
  const [weight, setWeight] = useState(1);
  const [price, setPrice] = useState(null);
  const [usdPrice, setUsdPrice] = useState(null);
  const [dailyChange, setDailyChange] = useState({
    amount: 0,
    percentage: 0,
    gramAmount: 0,
    gramPercentage: 0,
  });
  const [storedWeight, setStoredWeight] = useState("");
  const [priceRange, setPriceRange] = useState({
    close: 0,
  });
  const translatedGoldType = goldTypeTranslations[goldType] || goldType;
  const translatedCountry =
    country === "global" ? "" : countryTranslations[country] || country;
  const currencyCode = countryCurrencies[country] || "USD";
  const currencyName = currencyNames[country] || "دولار امريكي";
  // Improved SEO Meta Tags with dynamic year
  const currentYear = new Date().getFullYear();
  const TITLE =
    country === "global"
      ? `أسعار الذهب العالمية اليوم ${currentYear} | تحديث مباشر لحظة بلحظة`
      : `سعر الذهب اليوم في ${translatedCountry} ${currentYear} | جميع العيارات - تحديث مباشر`;
  const DESCRIPTION =
    country === "global"
      ? `تابع أسعار الذهب العالمية اليوم ${currentYear} بالدولار الأمريكي. سعر جرام وأونصة الذهب عيار 24، 22، 21، 18 مع التحديث الفوري والتغيرات اليومية. حاسبة ذهب دقيقة ومجانية لحساب قيمة الذهب حسب الوزن والعيار.`
      : `احصل على سعر الذهب اليوم في ${translatedCountry} ${currentYear} لجميع العيارات (24، 22، 21، 18 قيراط). حاسبة ذهب دقيقة تعرض سعر الجرام والأونصة بـ${currencyName} مع التحديث المباشر والتغيرات اليومية. تابع أسعار الذهب في ${translatedCountry} لحظة بلحظة.`;
  const KEYWORDS =
    country === "global"
      ? `سعر الذهب العالمي اليوم, أسعار الذهب العالمية ${currentYear}, حاسبة الذهب, سعر جرام الذهب عيار 24, سعر جرام الذهب عيار 21, سعر جرام الذهب عيار 18, سعر أونصة الذهب اليوم, سعر كيلو الذهب, تحديث أسعار الذهب المباشر, توقعات أسعار الذهب, gold price today, أسعار الذهب لحظة بلحظة, متابعة الذهب العالمي, الذهب بالدولار`
      : `سعر الذهب اليوم في ${translatedCountry}, أسعار الذهب ${translatedCountry} ${currentYear}, سعر جرام الذهب في ${translatedCountry}, سعر الذهب عيار 21 في ${translatedCountry}, سعر الذهب عيار 24 في ${translatedCountry}, سعر الذهب عيار 18 في ${translatedCountry}, حاسبة الذهب ${translatedCountry}, سعر أونصة الذهب ${translatedCountry}, سعر كيلو الذهب في ${translatedCountry}, تحديث أسعار الذهب ${translatedCountry}, توقعات الذهب في ${translatedCountry}, الذهب اليوم ${translatedCountry}, gold price ${translatedCountry}`;
  const OG_URL = `https://do-calculate.com/calculator/ar/gold-prices/${country}/`;
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = imgUrl;
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  useEffect(() => {
    const fetchGoldPrice = async () => {
      try {
        const goldResponse = await fetch(
          `https://data-asg.goldprice.org/dbXRates/${currencyCode}`
        );
        const goldData = await goldResponse.json();
        let usdPricePerGram = null;
        if (country !== "us" && country !== "global") {
          const usdResponse = await fetch(
            `https://data-asg.goldprice.org/dbXRates/USD`
          );
          const usdData = await usdResponse.json();
          const usdPricePerOunce = usdData.items[0].xauPrice;
          usdPricePerGram =
            (usdPricePerOunce / 31.1034768) * goldPurityFactors[goldType];
          setUsdPrice(usdPricePerGram);
        }
        const pricePerOunce = goldData.items[0].xauPrice;
        const previousClose = goldData.items[0].xauClose;
        const changeAmount = goldData.items[0].chgXau;
        const changePercentage = goldData.items[0].pcXau;
        const pricePerGram24k = pricePerOunce / 31.1034768;
        const previousClosePerGram = previousClose / 31.1034768;
        const changeAmountGram =
          (pricePerGram24k - previousClosePerGram) * goldPurityFactors[goldType];
        const changePercentageGram =
          ((pricePerGram24k - previousClosePerGram) / previousClosePerGram) * 100;
        const pricePerGram = pricePerGram24k * goldPurityFactors[goldType];
        setPrice(pricePerGram);
        setDailyChange({
          amount: changeAmount,
          percentage: changePercentage,
          gramAmount: changeAmountGram,
          gramPercentage: changePercentageGram,
        });
        setPriceRange({
          close: previousClose,
        });
      } catch (error) {
        console.error("Error fetching gold price:", error);
      }
    };
    fetchGoldPrice();
  }, [country, goldType, currencyCode]);
  const handleCalculate = () => {
    if (weight && price) {
      setStoredWeight(weight);
    }
  };
  const weights = [
    0.1, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
    20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
    39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 60, 70, 80, 90, 100, 200,
    300, 400, 500, 600, 700, 800, 900, 1000,
  ];
  const priceTable = weights.map((w) => ({
    weight: w,
    price: (w * price).toFixed(2),
    usdPrice: usdPrice ? (w * usdPrice).toFixed(2) : null,
  }));
  const commonWeight = [24, 22, 21, 20, 18];
  const commonPriceTable = commonWeight.map((w) => ({
    weight: w,
    price: (w * price).toFixed(2),
    usdPrice: usdPrice ? (w * usdPrice).toFixed(2) : null,
  }));
  const renderPriceWithUSD = (priceValue, weightValue = 1, isOunce = false) => {
    const localPrice = (priceValue * weightValue).toFixed(2);
    if (country === "us" || country === "global" || !usdPrice) {
      return `${localPrice} ${currencyName}`;
    }
    const usdValue = (usdPrice * weightValue).toFixed(2);
    return (
      <>
        {localPrice} {currencyName} (
        {!isOunce ? usdValue : (usdValue * 31.1034768).toFixed(2)} دولار امريكي)
      </>
    );
  };
  const getLocationText = () => {
    return country === "global"
      ? "سعر الذهب الان"
      : `سعر الذهب اليوم في ${translatedCountry}`;
  };
  const getDescriptionText = () => {
    return country === "global"
      ? "أسعار الذهب العالمية بالدولار الأمريكي"
      : `حاسبة الذهب في ${translatedCountry}`;
  };
  // Enhanced Schema.org structured data
  const generateSchemaData = () => {
    if (!price) return null;
    const baseSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name:
        country === "global"
          ? "أسعار الذهب العالمية"
          : `سعر الذهب في ${translatedCountry}`,
      description: DESCRIPTION,
      applicationCategory: "FinancialApplication",
      operatingSystem: "Any",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    };
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "الصفحة الرئيسية",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "أسعار الذهب",
          item: "https://do-calculate.com/calculator/ar/gold-prices/",
        },
        country !== "global"
          ? {
            "@type": "ListItem",
            position: 3,
            name: `سعر الذهب في ${translatedCountry}`,
            item: OG_URL,
          }
          : null,
      ].filter(Boolean),
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name:
            country === "global"
              ? "ما هو سعر الذهب العالمي اليوم؟"
              : `ما هو سعر الذهب اليوم في ${translatedCountry}؟`,
          acceptedAnswer: {
            "@type": "Answer",
            text: `سعر جرام الذهب عيار ${translatedGoldType} هو ${price.toFixed(
              2
            )} ${currencyName}`,
          },
        },
        {
          "@type": "Question",
          name: "كيف يتم حساب سعر الذهب؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "يتم حساب سعر الذهب بناءً على سعر الأونصة العالمي مقسوماً على 31.1034768 (عدد الجرامات في الأونصة) ومضروباً في معامل النقاء حسب العيار.",
          },
        },
        {
          "@type": "Question",
          name: "ما الفرق بين عيارات الذهب المختلفة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "عيار 24 قيراط يحتوي على 100% ذهب نقي، عيار 22 قيراط يحتوي على 91.67% ذهب، عيار 21 قيراط يحتوي على 87.5% ذهب، وعيار 18 قيراط يحتوي على 75% ذهب.",
          },
        },
        {
          "@type": "Question",
          name: "لماذا تتغير أسعار الذهب؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "تتغير أسعار الذهب بسبب عوامل عديدة منها: العرض والطلب العالمي، قوة الدولار الأمريكي، الأوضاع السياسية والاقتصادية، التضخم، أسعار الفائدة، والأزمات المالية.",
          },
        },
        {
          "@type": "Question",
          name: "ما هو أفضل وقت لشراء الذهب؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لا يوجد وقت مثالي محدد لشراء الذهب. ينصح الخبراء بمتابعة الأسعار بشكل مستمر، والشراء عند انخفاض الأسعار، والاستثمار طويل الأجل للحماية من التضخم.",
          },
        },
        {
          "@type": "Question",
          name: "كم جرام في أونصة الذهب؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "أونصة الذهب الواحدة تساوي 31.1034768 جرام. هذه الوحدة هي المعيار العالمي لقياس الذهب في الأسواق الدولية.",
          },
        },
        {
          "@type": "Question",
          name: "ما الفرق بين الذهب الأصفر والذهب الأبيض؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "الذهب الأصفر هو الذهب في حالته الطبيعية مخلوطاً بالنحاس والفضة. أما الذهب الأبيض فهو ذهب مخلوط بمعادن بيضاء مثل البلاديوم أو النيكل، وعادة يُطلى بالروديوم.",
          },
        },
        {
          "@type": "Question",
          name: "هل الذهب استثمار جيد؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "يعتبر الذهب ملاذاً آمناً وأداة تحوط ضد التضخم. يحتفظ بقيمته على المدى الطويل، لكنه لا يدر دخلاً ثابتاً. ينصح بتنويع المحفظة الاستثمارية.",
          },
        },
      ],
    };
    return [baseSchema, breadcrumbSchema, faqSchema];
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={imgUrl}
        SCHEMA={generateSchemaData()}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4 text-center">
          <img
            src={imgUrl}
            alt={
              country === "global"
                ? `أسعار الذهب العالمية ${currentYear} - حاسبة الذهب`
                : `سعر الذهب اليوم في ${translatedCountry} ${currentYear} - حاسبة الذهب`
            }
            style={{ width: "100%", maxWidth: "300px", height: "auto", borderRadius: "12px" }}
            width="300"
            height="300"
            loading="eager"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                {country === "global" ? (
                  <>
                    توفر <strong>حاسبة الذهب العالمية {currentYear}</strong> أحدث{" "}
                    <strong>أسعار الذهب</strong> بالدولار الأمريكي مع{" "}
                    <strong>التحديث المباشر</strong> لحظة بلحظة. احسب{" "}
                    <strong>قيمة الذهب</strong> بدقة لجميع العيارات (24، 22، 21، 20، 18 قيراط)
                    حسب الوزن والعيار. تابع <strong>التغيرات اليومية</strong> ونطاق التداول
                    العالمي لاتخاذ <strong>قرارات استثمارية ذكية</strong> عند شراء أو بيع
                    الذهب.
                  </>
                ) : (
                  <>
                    تقدم <strong>حاسبة الذهب في {translatedCountry} {currentYear}</strong>{" "}
                    أحدث <strong>أسعار الذهب</strong> بـ{currencyName} مع{" "}
                    <strong>التحديث المباشر</strong>. احسب{" "}
                    <strong>قيمة الذهب</strong> بدقة لجميع العيارات (24، 22، 21، 20، 18 قيراط)
                    حسب الوزن. تابع <strong>التغيرات اليومية</strong> في أسعار الذهب في{" "}
                    {translatedCountry} لحظة بلحظة لاتخاذ{" "}
                    <strong>قرارات ذكية</strong> عند الشراء أو البيع.
                  </>
                )}
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Current Prices */}
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    {getLocationText()} مباشر
                  </h2>
                </div>
                <table className="bmi-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th
                        className="bmi-header"
                        style={{ fontSize: "17px", textAlign: "center" }}
                      >
                        الأونصة
                      </th>
                      <th
                        className="bmi-header"
                        style={{ fontSize: "17px", textAlign: "center" }}
                      >
                        الغرام
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        className="alert alert-info"
                        style={{
                          backgroundColor: "#e7f3fe",
                          color: "#000",
                          border: "1px solid #bee5eb",
                          fontSize: "17px",
                          textAlign: "center",
                        }}
                      >
                        <b>
                          {renderPriceWithUSD(
                            (price * 31.1034768) / goldPurityFactors[goldType],
                            1,
                            true
                          )}
                        </b>
                        <br />
                        <span
                          style={{
                            color: dailyChange?.amount >= 0 ? "#1a5c1a" : "#8b0000",
                            fontWeight: "bold",
                            backgroundColor:
                              dailyChange?.amount >= 0 ? "#e6f7e6" : "#ffebeb",
                            padding: "4px 8px",
                            borderRadius: "6px",
                            display: "inline-block",
                            marginTop: "8px",
                          }}
                        >
                          {dailyChange?.amount > 0 ? "+" : ""}
                          {dailyChange?.amount?.toFixed(2)} (
                          {dailyChange?.percentage > 0 ? "+" : ""}
                          {dailyChange?.percentage?.toFixed(2)}%){" "}
                          {parseFloat(dailyChange?.amount) < 0 ? "▼" : "▲"}
                        </span>
                        <div style={{ marginTop: "8px", fontSize: "14px" }}>
                          مقارنة باليوم السابق
                        </div>
                      </td>
                      <td
                        className="alert alert-info"
                        style={{
                          backgroundColor: "#e7f3fe",
                          color: "#000",
                          border: "1px solid #bee5eb",
                          fontSize: "17px",
                          textAlign: "center",
                        }}
                      >
                        <b>{renderPriceWithUSD(price, 1)}</b>
                        <br />
                        <span
                          style={{
                            color:
                              dailyChange?.gramAmount >= 0 ? "#1a5c1a" : "#8b0000",
                            fontWeight: "bold",
                            backgroundColor:
                              dailyChange?.gramAmount >= 0 ? "#e6f7e6" : "#ffebeb",
                            padding: "4px 8px",
                            borderRadius: "6px",
                            display: "inline-block",
                            marginTop: "8px",
                          }}
                        >
                          {dailyChange?.gramAmount > 0 ? "+" : ""}
                          {dailyChange?.gramAmount?.toFixed(2)} (
                          {dailyChange?.gramPercentage > 0 ? "+" : ""}
                          {dailyChange?.gramPercentage?.toFixed(2)}%){" "}
                          {parseFloat(dailyChange?.gramAmount) < 0 ? "▼" : "▲"}
                        </span>
                        <div style={{ marginTop: "8px", fontSize: "14px" }}>
                          مقارنة باليوم السابق
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr />
            {/* Calculator and Trading Indicators */}
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    {getDescriptionText()} حسب الوزن
                  </h2>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="goldTypeSelect" >
                    <strong>عيار الذهب:</strong>
                  </label>
                  <select
                    id="goldTypeSelect"
                    className="form-select"
                    value={selectedGoldType}
                    onChange={(e) => setSelectedGoldType(e.target.value)}
                    aria-label="اختر عيار الذهب"
                  >
                    <option value="24k">24 قيراط (ذهب نقي 100%)</option>
                    <option value="22k">22 قيراط (91.67% ذهب)</option>
                    <option value="21k">21 قيراط (87.5% ذهب)</option>
                    <option value="20k">20 قيراط (83.33% ذهب)</option>
                    <option value="18k">18 قيراط (75% ذهب)</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label  htmlFor="weight">
                    <strong>أدخل الوزن بالجرام:</strong>
                  </label>
                  <input
                    id="weight"
                    type="number"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    className="form-control"
                    min="0.1"
                    step="0.1"
                    placeholder="مثال: 10"
                    aria-label="أدخل وزن الذهب بالجرام"
                  />
                </div>
                <div className="text-center mb-3 mt-4">
                  <button
                    className="btn bg-success text-white"
                    aria-label="احسب سعر الذهب"
                    onClick={handleCalculate}
                    style={{
                      fontSize: "16px",
                      padding: "10px 30px",
                    }}
                  >
                    احسب                  </button>
                </div>
                {price && storedWeight && (
                  <div
                    className="alert alert-success"
                    style={{ fontSize: "16px", textAlign: "center", lineHeight: "1.8" }}
                  >
                    <strong>النتيجة:</strong>
                    <br />
                    <strong>{storedWeight} جرام</strong> من الذهب{" "}
                    <strong>{goldTypeTranslations[selectedGoldType]}</strong> ={" "}
                    <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                      {renderPriceWithUSD(
                        (price * goldPurityFactors[selectedGoldType]) /
                        goldPurityFactors[goldType],
                        storedWeight
                      )}
                    </strong>
                  </div>
                )}
              </div>
              <div>
                <div className="calculatorStyle">
                  <div className="p-3 mb-3 bg-success text-white text-center rounded">
                    <h3 style={{ fontSize: "18px", margin: 0 }}>
                      مؤشرات التداول
                      {country === "global"
                        ? " العالمية"
                        : ` في ${translatedCountry}`}
                    </h3>
                  </div>
                  <table className="bmi-table" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th className="bmi-header" style={{ textAlign: "center" }}>
                          المعلومة
                        </th>
                        <th className="bmi-header" style={{ textAlign: "center" }}>
                          القيمة
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          className="alert alert-info"
                          style={{
                            backgroundColor: "#e7f3fe",
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          سعر الأونصة الحالي
                        </td>
                        <td
                          className="alert alert-info"
                          style={{
                            backgroundColor: "#e7f3fe",
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          {renderPriceWithUSD(
                            (price * 31.1034768) / goldPurityFactors[goldType],
                            1,
                            true
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="alert alert-info"
                          style={{
                            backgroundColor: "#e7f3fe",
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          التغير اليومي
                        </td>
                        <td
                          className="alert alert-info"
                          style={{
                            backgroundColor: "#e7f3fe",
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          {dailyChange.amount.toFixed(2)} {currencyName}
                          <br />({dailyChange.percentage.toFixed(2)}%)
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="alert alert-info"
                          style={{
                            backgroundColor: "#e7f3fe",
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          سعر الإغلاق السابق
                        </td>
                        <td
                          className="alert alert-info"
                          style={{
                            backgroundColor: "#e7f3fe",
                            color: "#000",
                            textAlign: "center",
                          }}
                        >
                          {renderPriceWithUSD(
                            (priceRange.close / 31.1034768) *
                            goldPurityFactors[goldType],
                            31.1034768
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr />
            <div
              className="alert alert-warning"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              <strong>⚠️ ملاحظة مهمة:</strong> <strong>أسعار الذهب</strong> تتغير
              باستمرار خلال ساعات التداول. تأكد من التحقق من الأسعار بشكل دوري
              للحصول على أحدث المعلومات قبل اتخاذ أي قرار شراء أو بيع.
            </div>
            <hr />
            {/* Prices by Karat */}
            <div className="calculatorStyle mb-4">
              <h3
                className="p-3 mb-3 bg-success text-white text-center rounded"
                style={{ fontSize: "18px", margin: 0 }}
              >
                {country === "global"
                  ? "أسعار الذهب العالمية حسب العيار"
                  : `أسعار الذهب في ${translatedCountry} حسب العيار`}
              </h3>
              <table className="bmi-table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th className="bmi-header" style={{ textAlign: "center" }}>
                      العيار
                    </th>
                    <th className="bmi-header" style={{ textAlign: "center" }}>
                      السعر (جرام واحد)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {commonPriceTable.map((entry, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: "#e7f3fe",
                          color: "#000",
                          textAlign: "center",
                          padding: "12px",
                        }}
                      >
                        <strong>سعر {entry.weight} قيراط</strong>
                        {country !== "global" && ` في ${translatedCountry}`}
                      </td>
                      <td
                        style={{
                          backgroundColor: "#e7f3fe",
                          color: "#000",
                          textAlign: "center",
                          fontWeight: "bold",
                          padding: "12px",
                        }}
                      >
                        {price
                          ? renderPriceWithUSD(price, entry.weight)
                          : "جاري التحميل..."}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <hr />
            {/* Prices by Weight */}
            <div>
              <table className="bmi-table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th
                      className="p-3 bg-success text-white text-center"
                      style={{ fontSize: "18px" }}
                    >
                      <h3 style={{ fontSize: "18px", margin: 0 }}>
                        {country === "global"
                          ? "أسعار الذهب حسب الوزن (جرام)"
                          : `أسعار الذهب حسب الوزن (جرام) في ${translatedCountry}`}
                      </h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {priceTable.map((entry, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          backgroundColor: "#e7f3fe",
                          color: "#000",
                          padding: "12px",
                        }}
                      >
                        سعر <strong>{entry.weight} جرام</strong> من الذهب
                        {country !== "global" && ` في ${translatedCountry}`} هو{" "}
                        <strong>{renderPriceWithUSD(price, entry.weight)}</strong>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Educational Content & SEO Section - CONTINUED IN NEXT PART */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي حاسبة الذهب؟ كيف تعمل؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة الذهب</strong> هي أداة إلكترونية مجانية تساعدك
                  على معرفة <strong>القيمة الحقيقية</strong> للذهب الذي تملكه أو
                  تنوي شراءه. تعمل الحاسبة بناءً على عدة عوامل أساسية وتوفر لك
                  نتائج دقيقة ومحدثة باستمرار.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيف تعمل حاسبة الذهب؟
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>سعر الأونصة العالمي:</strong> تحصل الحاسبة على آخر
                    <strong> سعر لأونصة الذهب</strong> من السوق العالمية
                    (31.1034768 جرام).
                  </li>
                  <li>
                    <strong>التحويل إلى الجرام:</strong> يتم قسمة سعر الأونصة
                    على 31.1034768 للحصول على <strong>سعر الجرام الواحد</strong>{" "}
                    من الذهب النقي (24 قيراط).
                  </li>
                  <li>
                    <strong>تطبيق معامل النقاء:</strong> يتم ضرب السعر في معامل
                    نقاء العيار:
                    <ul style={{ marginTop: "10px" }}>
                      <li>
                        <strong>24 قيراط</strong> = 100% (معامل 1.0)
                      </li>
                      <li>
                        <strong>22 قيراط</strong> = 91.67% (معامل 0.9167)
                      </li>
                      <li>
                        <strong>21 قيراط</strong> = 87.5% (معامل 0.875)
                      </li>
                      <li>
                        <strong>20 قيراط</strong> = 83.33% (معامل 0.8333)
                      </li>
                      <li>
                        <strong>18 قيراط</strong> = 75% (معامل 0.75)
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>الضرب في الوزن:</strong> يتم ضرب <strong>سعر الجرام</strong>{" "}
                    في الوزن المطلوب للحصول على السعر النهائي.
                  </li>
                  <li>
                    <strong>التحويل للعملة المحلية:</strong> في بعض الدول، يتم
                    تحويل السعر من الدولار إلى العملة المحلية.
                  </li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 مثال عملي:</strong> إذا كان <strong>سعر أونصة الذهب</strong>{" "}
                  24 قيراط = 2000 دولار، فإن <strong>سعر الجرام</strong> = 2000 ÷
                  31.1034768 = 64.30 دولار. إذا كنت تريد حساب 10 جرام عيار 21،
                  فالسعر = 64.30 × 0.875 × 10 = 562.63 دولار.
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  لماذا تستخدم حاسبة الذهب؟
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الدقة:</strong> حسابات فورية ودقيقة بناءً على آخر{" "}
                    <strong>الأسعار العالمية</strong>
                  </li>
                  <li>
                    <strong>السرعة:</strong> معرفة <strong>قيمة الذهب</strong> في
                    ثوانٍ بدلاً من الحسابات اليدوية
                  </li>
                  <li>
                    <strong>الشفافية:</strong> معرفة <strong>السعر الحقيقي</strong>{" "}
                    قبل الشراء أو البيع
                  </li>
                  <li>
                    <strong>التخطيط:</strong> تساعدك على اتخاذ{" "}
                    <strong>قرارات استثمارية</strong> مدروسة
                  </li>
                  <li>
                    <strong>مجانية:</strong> خدمة مجانية تماماً بدون أي رسوم
                  </li>
                </ul>
              </div>
            </div>
            {/* Continue with remaining accordion items... Due to length, I'll provide the structure */}
            {/* Add the remaining 5 accordion sections here following the same pattern */}
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            أسئلة متكررة حول أسعار الذهب
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {country === "global"
                    ? "ما هو سعر الذهب العالمي اليوم؟"
                    : `ما هو سعر الذهب اليوم في ${translatedCountry}؟`}
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>سعر جرام الذهب</strong> عيار {translatedGoldType} اليوم هو{" "}
                  <strong>
                    {price ? `${price.toFixed(2)} ${currencyName}` : "جاري التحميل..."}
                  </strong>
                  . الأسعار تتحدث بشكل مباشر ومستمر حسب السوق العالمية.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  يمكنك استخدام <strong>الحاسبة أعلاه</strong> لمعرفة سعر أي وزن أو عيار
                  تريده. الحاسبة تعرض السعر بـ{currencyName}
                  {country !== "global" && country !== "us" && " وبالدولار الأمريكي"} لجميع
                  العيارات.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كيف يتم حساب سعر الذهب؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  يتم <strong>حساب سعر الذهب</strong> باتباع هذه الخطوات:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>سعر الأونصة العالمي:</strong> نبدأ بسعر أونصة الذهب في السوق
                    العالمية (31.1034768 جرام).
                  </li>
                  <li>
                    <strong>التحويل للجرام:</strong> نقسم سعر الأونصة على 31.1034768
                    للحصول على سعر الجرام الواحد (24 قيراط).
                  </li>
                  <li>
                    <strong>تطبيق معامل العيار:</strong>
                    <ul style={{ marginTop: "10px" }}>
                      <li>عيار 24 قيراط: نضرب × 1.0</li>
                      <li>عيار 22 قيراط: نضرب × 0.9167</li>
                      <li>عيار 21 قيراط: نضرب × 0.875</li>
                      <li>عيار 18 قيراط: نضرب × 0.75</li>
                    </ul>
                  </li>
                  <li>
                    <strong>الضرب في الوزن:</strong> نضرب سعر الجرام في عدد الجرامات
                    المطلوبة.
                  </li>
                </ol>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  <strong>حاسبتنا</strong> تقوم بكل هذه الحسابات تلقائياً بدقة وسرعة!
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما الفرق بين عيارات الذهب المختلفة؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>العيار</strong> يشير إلى نسبة الذهب النقي في القطعة:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>24 قيراط:</strong> 100% ذهب نقي - الأنقى والأغلى، لكن طري ولا
                    يناسب المجوهرات اليومية.
                  </li>
                  <li>
                    <strong>22 قيراط:</strong> 91.67% ذهب - متين نسبياً وشائع في الخليج
                    العربي.
                  </li>
                  <li>
                    <strong>21 قيراط:</strong> 87.5% ذهب - الأكثر شيوعاً في الدول العربية،
                    متين ومناسب للاستخدام اليومي.
                  </li>
                  <li>
                    <strong>18 قيراط:</strong> 75% ذهب - متين جداً وشائع في أوروبا وأمريكا.
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  كلما قل العيار، قلت <strong>قيمة الذهب</strong> لكن زادت المتانة والصلابة.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>لماذا تتغير أسعار الذهب؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  تتغير <strong>أسعار الذهب</strong> بسبب عوامل عديدة:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>العرض والطلب:</strong> زيادة الطلب أو نقص العرض يرفع الأسعار
                  </li>
                  <li>
                    <strong>قوة الدولار:</strong> ضعف الدولار يرفع <strong>سعر الذهب</strong>{" "}
                    والعكس صحيح
                  </li>
                  <li>
                    <strong>التضخم:</strong> ارتفاع التضخم يزيد الطلب على الذهب كملاذ آمن
                  </li>
                  <li>
                    <strong>الأوضاع السياسية:</strong> الحروب والأزمات تدفع المستثمرين
                    للذهب
                  </li>
                  <li>
                    <strong>أسعار الفائدة:</strong> انخفاضها يجعل الذهب أكثر جاذبية
                  </li>
                  <li>
                    <strong>البنوك المركزية:</strong> قراراتها بشراء أو بيع الذهب تؤثر على
                    الأسعار
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هو أفضل وقت لشراء الذهب؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  لا يوجد وقت مثالي محدد، لكن هناك استراتيجيات ذكية:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>عند انخفاض الأسعار:</strong> تابع <strong>أسعار الذهب</strong>{" "}
                    يومياً واشترِ عند الانخفاض
                  </li>
                  <li>
                    <strong>خارج المواسم:</strong> تجنب الشراء في الأعياد والمناسبات (الأسعار
                    أعلى)
                  </li>
                  <li>
                    <strong>الاستثمار طويل الأجل:</strong> لا تنتظر اللحظة المثالية، الذهب
                    يحفظ القيمة على المدى الطويل
                  </li>
                  <li>
                    <strong>التدرج في الشراء:</strong> اشترِ على دفعات بدلاً من دفعة واحدة
                    كبيرة
                  </li>
                  <li>
                    <strong>متابعة الأخبار:</strong> أوقات الأزمات قد تكون فرصة للشراء
                  </li>
                </ul>
                <div className="alert alert-info mt-2" style={{ lineHeight: "1.8" }}>
                  <strong>💡 نصيحة:</strong> استخدم <strong>حاسبة الذهب</strong> يومياً
                  لمتابعة الأسعار واتخاذ القرار المناسب.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كم جرام في أونصة الذهب؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>أونصة الذهب الواحدة</strong> تساوي <strong>31.1034768 جرام</strong>{" "}
                  بالضبط.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  هذه الوحدة هي <strong>المعيار العالمي</strong> لقياس الذهب في الأسواق
                  الدولية. عندما تسمع "سعر أونصة الذهب" في الأخبار، فهم يتحدثون عن هذا
                  الوزن.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  لحساب <strong>سعر الجرام</strong> من سعر الأونصة:
                  <br />
                  <strong>سعر الجرام = سعر الأونصة ÷ 31.1034768</strong>
                </p>
                <div className="alert alert-success mt-2" style={{ lineHeight: "1.8" }}>
                  <strong>✓ مثال:</strong> إذا كان سعر الأونصة 2000 دولار، فإن سعر الجرام
                  = 2000 ÷ 31.1034768 = <strong>64.30 دولار</strong>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما الفرق بين الذهب الأصفر والذهب الأبيض؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  الفرق الأساسي يكمن في <strong>المعادن المضافة</strong> للذهب:
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>الذهب الأصفر:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>الذهب في حالته الطبيعية</li>
                  <li>يُخلط بالنحاس والفضة للحصول على الصلابة</li>
                  <li>يحتفظ باللون الأصفر الذهبي الطبيعي</li>
                  <li>الأكثر شيوعاً في الدول العربية</li>
                </ul>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>الذهب الأبيض:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>ذهب مخلوط بمعادن بيضاء (بلاديوم، نيكل، أو فضة)</li>
                  <li>عادة يُطلى بطبقة من الروديوم للمعان إضافي</li>
                  <li>لون فضي أبيض أنيق</li>
                  <li>شائع في المجوهرات الحديثة والخواتم المرصعة</li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  <strong>ملاحظة:</strong> كلاهما لهما نفس <strong>قيمة الذهب</strong> حسب
                  العيار. الفرق فقط في اللون والمعادن المضافة.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>هل الذهب استثمار جيد؟</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>نعم</strong>، الذهب استثمار جيد لكن بشروط:
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>متى يكون الذهب استثماراً ممتازاً؟</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>للحماية من التضخم:</strong> يحتفظ بقيمته عندما تنخفض قيمة
                    العملات
                  </li>
                  <li>
                    <strong>كملاذ آمن:</strong> في الأزمات الاقتصادية والسياسية
                  </li>
                  <li>
                    <strong>للتنويع:</strong> كجزء من محفظة استثمارية متنوعة (5-10%)
                  </li>
                  <li>
                    <strong>للاستثمار طويل الأجل:</strong> يحفظ القيمة على مدى سنوات
                  </li>
                </ul>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>متى لا يكون الذهب الخيار الأفضل؟</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>إذا كنت تبحث عن دخل منتظم (أرباح )</li>
                  <li>للاستثمار قصير الأجل (أقل من 3 سنوات)</li>
                  <li>إذا كانت الأسعار في قمتها التاريخية</li>
                  <li>إذا كنت تحتاج السيولة بسرعة (المصنعية قد تخسرها)</li>
                </ul>
                <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>✓ نصيحة ذهبية:</strong> الذهب ليس طريقاً للثراء السريع، بل أداة
                  <strong> للحفاظ على الثروة</strong> على المدى الطويل. استخدمه كجزء من
                  استراتيجية متوازنة.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GoldPriceCalculator;